import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	radioGroup: {
		flex: 1,
		gap: theme.spacing.xxsmall,
	},
	radioItem: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		width: '100%',
		justifyContent: 'space-between',
	},
}));
